module.exports = __webpack_public_path__ + "static/img/footerlogo.7232432.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerlogo.png
// module id = ZkUn
// module chunks = 1